<template>
  <a-modal
    title="绑定点价关系"
    :width="480"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item :label="relatedLabel" v-if="param !== undefined">
              <a-tag closable @close="deleteRelated(param)"> {{ param.sell_contract }}</a-tag>
            </a-form-item>
            <a-form-item :label="labelTable">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="contractFetching ? undefined : null"
                show-search
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '选择销售合同' },
                    ],
                  },
                ]"
                placeholder="请输入合同编号"
                @search="this.tradeSellContractSearch"
              >
                <a-spin v-if="contractFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in sellContractList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import {
  sell_contract_list, sell_contract_related_valence_vertex_delete,
  sell_contract_related_valence_vertex_list
} from '@/api/trade_sell_contract'

// 表单字段
const fields = ['sell_contract_id']
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }
    }
    this.tradeSellContractSearch = debounce(this.handleTradeSellContractSearch, 800)
    return {
      contractFetching: false,
      sellContractList: [],
      param: undefined,
      form: this.$form.createForm(this)
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  computed: {
    labelTable () {
      return () => {
        if (this.model['type'] === 1) {
          return '销售合同'
        } else {
          return '采购合同'
        }
      }
    },
    relatedLabel () {
      return () => {
        if (this.model['type'] === 1) {
          return '已绑定销售合同'
        } else {
          return '已绑定采购合同'
        }
      }
    }
  },
  mounted () {
    this.loadRelatedContractInfo()
  },
  methods: {
    loadRelatedContractInfo () {
      sell_contract_related_valence_vertex_list({ purchase_contract_id: this.model.id }).then(res => {
        if (res.code === 1000 && res.data.entries.length > 0) {
          this.param = res.data.entries[0]
        }
      })
    },
    handleTradeSellContractSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.contractFetching = true
      sell_contract_list({ filter: true, type: 2, unit_price_type: 2, number: value }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.contractFetching = false
      })
    },
    deleteRelated (data) {
      console.log(data)
      sell_contract_related_valence_vertex_delete(data.id).then(res => {
        if (res.code === 1000) {
          this.param = undefined
        }
      })
    }
  }
}
</script>
